<script setup lang="ts">
import store from "@/store";
import chunk from "lodash-es/chunk";
import { useRouter } from "vue-router";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import {
  mobileHeader,
  footerMenu,
  mobileMenu,
  fullLoading,
} from "@/common/components";

interface MenuListType {
  icon: string;
  label?: string;
  url?: string;
  key: string;
  active?: boolean;
}

const { t } = useI18n();
const router = useRouter();

const props = defineProps<{
  accountId: string;
  menuList: MenuListType[];
}>();

const headerHeight = "4rem";
const footerHeight = "4.4rem";

const mobileMenuOpen = ref<string | null>(null);

const currentRoute = computed(() => router.currentRoute.value.path);

const footerMenuList = computed(() => [
  ...chunk(props.menuList || [], 3)[0],
  {
    key: "menu",
    icon: "grid",
    label: t("common.labels.menu"),
  },
]);

const tabActive = computed(() => {
  return props.menuList.find((item) => currentRoute.value.includes(item.url))
    ?.key;
});

function openFooterMenu(value: any) {
  mobileMenuOpen.value = value.key;
}

function menuMobileClose() {
  mobileMenuOpen.value = null;
}
</script>

<template>
  <section class="screen">
    <section class="pages">
      <mobile-header :height="headerHeight" background="#fff" />
      <main class="main">
        <slot name="main"></slot>
      </main>
      <footer-menu
        background="#fff"
        :menu-list="footerMenuList"
        :height="footerHeight"
        :active="tabActive"
        @open="openFooterMenu"
      />
    </section>

    <template v-if="store.getters.loading">
      <full-loading />
    </template>

    <template v-if="mobileMenuOpen === 'menu'">
      <mobile-menu
        :menu-list="menuList"
        :active="tabActive"
        @close="menuMobileClose()"
      />
    </template>
  </section>
</template>

<style lang="scss" scoped>
$header-height: v-bind("headerHeight");
$footer-height: v-bind("footerHeight");

.screen {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100dvh;

  .pages {
    display: flex;
    flex-direction: column;

    main {
      display: flex;
      flex-direction: column;
      padding-block: 1rem;
      padding-inline: 1rem;
      height: calc(100dvh - $header-height - $footer-height);
      overflow-y: auto;
    }
  }
}
</style>
